<template lang="pug">
  v-select(
    ref="root"
    v-bind="$attrs"
    v-model="model"
    readonly
    item-text="label"
    @click.native="onClick")
</template>

<script>
import {
  computed,
  ref
} from '@vue/composition-api'

import { page } from '@iez/core'
import { mdiHome } from '@mdi/js'

export default {
  inheritAttrs: false,

  // value + select props
  props: {
    value: String
  },

  setup (props, { emit, attrs }) {
    const menuIsOpened = ref(false)
    const root = ref(null)

    const model = computed({
      get: () => props.value,
      set: value => {
        emit(
          `input`,
          value
        )
      }
    })

    page.blockingMenu.set(() => menuIsOpened.value
      ? ({
        title: attrs.label,
        items: attrs.items
          .map(item => ({
            label: item,
            value: item === props.value
          })),
        select: {
          max: 1,
          min: 0
        },
        onClose: () => {
          menuIsOpened.value = false
          setTimeout(
            () => {
              root.value.blur()
            },
            0
          )
        },
        onResult: ({ indexes: [ index ] }) => {
          const result = attrs.items[index]
          emit(
            `input`,
            result
          )
        }
      }) : null
    )

    const onClick = () => {
      menuIsOpened.value = true
    }

    return {
      model,
      onClick,
      root,
      menuIsOpened
    }
  }
}
</script>
